import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-verify',
  templateUrl: './user-verify.component.html',
  styleUrls: ['./user-verify.component.css']
})
export class UserVerifyComponent implements OnInit {
  readonly REPLACER = "{TOKEN}"
  readonly URL = environment.API_URL + "verify/" + this.REPLACER;

  safeResource!: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    const url = this.URL.replace(this.REPLACER, this.route.snapshot.params.token);
    this.http.get(url, { responseType: 'text' })
    .subscribe({
      next: response => {
        // console.log(response);
        this.safeResource = this.sanitizer.bypassSecurityTrustHtml(response.replace("class=\"btn-verify\"", "class=\"btn-verify\" mat-button"));
      },
      error: error => {
        console.error(error);
      }
    })
  }

}
